import { Injectable } from '@angular/core';
import Projection from 'ol/proj/Projection';
import { addEquivalentProjections, get as getProjection } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import Map from 'ol/Map';
import View from 'ol/View';
import { defaults as defaultControls } from 'ol/control';

proj4.defs("EPSG:6706", "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs");
proj4.defs("EPSG:4258", "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs");

register(proj4);

@Injectable({
  providedIn: 'root'
})
export class MapService {

  RESOLUTION_TO_SCALE_METRIC_FACTOR = 3779.52000000000000047621952;

  _map = null;
  _layers = null;
  _view = null;

  constructor() {
    // for gml xy conversion
    var newProj = new Projection({
      code: 'http://www.opengis.net/gml/srs/epsg.xml#4326',
      axis: 'enu'
    });
    addEquivalentProjections([getProjection('EPSG:4326'), newProj]);
  }

  init(layers, target, view, mapControls) {
    this._layers = layers;
    this._view = view;

    this._map = new Map({
      controls: defaultControls({
        rotate: false
      }),
      layers: layers,
      target: target,
      view: view
    });

    for (var index = 0; index < mapControls.length; index++) {
      var mapControl = mapControls[index];
      this._map.addControl(mapControl);
    }
  }

  zoomToFeature(feature) {
    var ext = feature.getGeometry().getExtent();
    this._map.getView().fit(ext, this._map.getSize());
  }

  zoomToCoordinates(coordinates, fullExtent, zoom = 18, projection = 'EPSG:4326') {
    if (this.isPointInExtent(coordinates, fullExtent, projection) === false) {
      return false;
    }

    this._view.setCenter(coordinates);
    this._view.setZoom(zoom);    

    return true;
  }
  
  isPointInExtent(coordinates, fullExtent, projection = 'EPSG:4326') {
    if (coordinates[0] < fullExtent[0] || coordinates[0] > fullExtent[2] || coordinates[1] < fullExtent[1] || coordinates[1] > fullExtent[3]) {
      return false;
    } else {
      return true;
    }
  }
}
